const styles = (theme) => ({
    skeleton: {
        padding: 10,
    },
});

export default styles;
